// extracted by mini-css-extract-plugin
export default {"exportButton":"remote-backup-details-page-exportButton-PeqRgz","importButton":"remote-backup-details-page-importButton-I3qqi5"};